import { Box, ButtonBase, Typography } from '@mui/material';
import { FC } from 'react';
import {
	colorOverflowButtonSX,
	colorOverflowCircleSX,
	colorOverflowTextSX,
} from '@/components/blocks/ColorOverflowIndicator/styles';

interface Props {
	count: number;
}

export const ColorOverflowIndicator: FC<Props> = ({ count }) => (
	<ButtonBase aria-label={`+${count}`} sx={colorOverflowButtonSX}>
		<Box sx={colorOverflowCircleSX}>
			<Typography component="span" sx={colorOverflowTextSX}>
				{`+${count}`}
			</Typography>
		</Box>
	</ButtonBase>
);
